/* ======================================================
   ABOUT YOU — Physical Attributes
   ====================================================== */

export const PHYSICAL_BUILD_OPTIONS = {
  SLIM: "Slim",
  FIT: "Fit",
  MUSCULAR: "Muscular",
  AVERAGE: "Average",
  A_FEW_EXTRA_POUNDS: "A few extra pounds",
};

export const PIERCINGS_OPTIONS = {
  NONE: "None",
  JUST_EARS: "Just ears",
  A_FEW: "A Few",
  MANY: "Many",
  SKIP: "Skip",
};

export const TATTOOS_OPTIONS = {
  NONE: "None",
  A_FEW: "A Few",
  MANY: "Many",
  COVERED: "Covered",
  SKIP: "Skip",
};

export const GENDER_OPTIONS = {
  MALE: "Male",
  FEMALE: "Female",
  BOTH: "Both",
};

export const GENDER_OPTIONS_FILTER = {
  MALE: "Male",
  FEMALE: "Female",
};

export const WEIGHT_UNIT_OPTIONS = {
  KG: "KG",
  LBS: "LBS",
};

/* ======================================================
   ABOUT YOU — Lifestyle & Habits
   ====================================================== */

export const EXERCISE_HABITS_OPTIONS = {
  EXTREMELY_ACTIVE: "Extremely active",
  OCCASIONALLY_ACTIVE: "Occasionally active",
  NOT_ACTIVE: "Not active",
  SKIP: "Skip",
};

export const DRINKING_HABITS_OPTIONS = {
  NONE: "None",
  SOCIALLY: "Socially",
  REGULARLY: "Regularly",
  SKIP: "Skip",
};

export const SMOKING_TYPE_OPTIONS = {
  NONE: "None",
  CIGARETTES: "Cigarettes",
  CIGARS: "Cigars",
  MARIJUANA: "Marijuana",
  ALL: "All",
  SKIP: "Skip",
};

export const SMOKING_FREQUENCY_OPTIONS = {
  NEVER: "Never",
  OCCASIONALLY: "Occasionally",
  REGULARLY: "Regularly",
  SKIP: "Skip",
};

export const DIETARY_PREFERENCE_OPTIONS = {
  OMNIVORE: "Omnivore",
  VEGETARIAN: "Vegetarian",
  VEGAN: "Vegan",
  OTHER_FLEXIBLE: "Flexible, no preference",
};

export const PETS_OPTIONS = {
  NONE: "None",
  DOGS: "Dog(s)",
  CATS: "Cat(s)",
  OTHER: "Other",
  ALLERGIC_NO_PETS: "Allergic / No Pets",
  SKIP: "Skip",
};

export const RELIGION_SPIRITUALITY_OPTIONS = {
  RELIGIOUS_FAITH_CENTERED: "Faith-centered",
  SPIRITUAL_NOT_RELIGIOUS: "Spiritual but not religious",
  AGNOSTIC_UNSURE: "Agnostic / unsure",
  ATHEIST_SECULAR: "Atheist / secular",
};

export const RELATIONSHIP_STYLE_OPTIONS = {
  MONOGAMOUS: "Monogamous",
  OPEN_MINDED_FLEXIBLE: "Open-minded / Flexible",
  EXPLORING_UNDECIDED: "Exploring / Undecided",
  PREFER_NOT_TO_LABEL: "Prefer not to label",
  SKIP: "Skip",
};

export const FAMILY_PLANS_OPTIONS = {
  HAVE_CHILDREN_UNDER_18: "Have children (under 18)",
  WANT_KIDS_FUTURE: "Want kids in the future",
  // OPEN_TO_PARTNER_CHILDREN: "Open to partners with children (under 18)",
  PREFER_NO_CHILDREN: "Prefer not to have children",
  UNDECIDED: "Undecided",
  SKIP: "Skip",
};

/* ======================================================
   ABOUT YOU — Personality Traits
   ====================================================== */

export const PERSONALITY_TYPE_OPTIONS = {
  TYPE_A: "Type A",
  TYPE_B: "Type B",
  SKIP: "Skip",
};

export const SOCIAL_ENERGY_STYLE_OPTIONS = {
  INTROVERTED: "Introverted",
  EXTROVERTED: "Extroverted",
  BALANCED_SOCIALLY: "Balanced socially",
  SOCIALLY_SELECTIVE: "Socially selective",
};

export const TEMPERAMENT_TYPE_OPTIONS = {
  CHOLERIC: "Choleric",
  SANGUINE: "Sanguine",
  MELANCHOLIC: "Melancholic",
  PHLEGMATIC: "Phlegmatic",
  SKIP: "Skip",
};

export const PERSONALITY_STYLE_OPTIONS = {
  DOMINANT: "D (Dominant)",
  INFLUENTIAL: "I (Influential)",
  STEADY: "S (Steady)",
  CONSCIENTIOUS: "C (Conscientious)",
  SKIP: "Skip",
};

/* ======================================================
   ABOUT YOU — Interests & Hobbies
   ====================================================== */

export const INTERESTS_AND_HOBBIES_OPTIONS = {
  ART_GALLERIES: "Art Galleries",
  THEATRE: "Theatre",
  MUSEUMS: "Museums",
  OPERA: "Opera",
  ARCHITECTURE: "Architecture",
  CLASSICAL_MUSIC: "Classical Music",

  FILM: "Film",
  LIVE_MUSIC: "Live Music",
  JAZZ: "Jazz",
  COMEDY: "Comedy",
  SHOWS: "Shows",
  PODCASTS: "Podcasts",

  WEEKEND_GETAWAYS: "Weekend Getaways",
  BEACH_RESORTS: "Beach Resorts",
  CRUISES: "Cruises",
  CULTURAL_TRAVEL: "Cultural Travel",
  ADVENTURE_TRAVEL: "Adventure Travel",

  WINE_TASTING: "Wine Tasting",
  FINE_DINING: "Fine Dining",
  COOKING: "Cooking",
  STREET_FOOD: "Street Food",
  FOODIE_EXPERIENCES: "Foodie Experiences",

  GYM: "Gym",
  TENNIS: "Tennis",
  GOLF: "Golf",
  YOGA: "Yoga",
  SPA_DAYS: "Spa Days",
  HIKING: "Hiking",

  BASKETBALL: "Basketball",
  FOOTBALL: "Football",
  SOCCER: "Soccer",
  GOLF_SPECTATOR: "Golf (Spectator)",
  FORMULA_1: "Formula 1",
  HORSE_RACING: "Horse Racing",

  READING: "Reading",
  PHILOSOPHY: "Philosophy",
  CURRENT_AFFAIRS: "Current Affairs",
  INVESTING: "Investing",
  HISTORY: "History",

  FASHION: "Fashion",
  CARS: "Cars",
  YACHTS: "Yachts",
  WATCHES: "Watches",
  INTERIOR_DESIGN: "Interior Design",

  PRIVATE_EVENTS: "Private Events",
  CHARITY_GALAS: "Charity Galas",
  NIGHTLIFE: "Nightlife",
  NETWORKING_MIXERS: "Networking Mixers",

  STARTUPS: "Start-ups",
  AI: "AI",
  GADGETS: "Gadgets",
  CRYPTO: "Crypto",
  SUSTAINABILITY: "Sustainability",
};

/* ======================================================
   WHAT ARE YOU LOOKING FOR?
   ====================================================== */

export const LOOKING_FOR_OPTIONS = {
  CASUAL: "Casual",
  SHORT_TERM: "Short Term",
  LONG_TERM: "Long Term",
  LIFE_PARTNER: "Life-Partner",
  FRIENDS: "Friends",
  CONNECTIONS: "Connections",
  UNDECIDED: "Undecided",
  MARRIAGE: "Marriage",
  ALL: "All",
};

export const ETHNICITY_OPTIONS = {
  WHITE: "White",
  BLACK: "Black",
  ASIAN: "Asian",
  HISPANIC: "Hispanic / Latino",
  INDIAN: "Indian / South Asian",
  MIDDLE_EASTERN: "Middle Eastern",
  OTHER: "Other / Multiracial",
};

export const NOTIFICATION_TYPE_CATEGORIES = {
  // Match related
  MATCH_APPROVED: "match",
  MATCH_REJECTED: "match",
  NEW_MATCH: "match",
  PROFILE_LIKED: "match",

  // Circle related
  CIRCLE_INVITE_RECEIVED: "circle",
  CIRCLE_INVITE_ACCEPTED: "circle",
  CIRCLE_INVITE_DECLINED: "circle",
  CIRCLE_MEMBER_JOINED: "circle",
  CIRCLE_VOTE_SUBMITTED: "circle",
  CIRCLE_OVERRIDE: "circle",

  // Connection related
  NEW_MESSAGE: "message",
  VIDEO_CHAT_INVITE: "message",
  ALBUM_UNLOCKED: "message",

  // Token related
  TOKEN_PURCHASED: "token",
  TOKEN_SPENT: "token",
  LOW_TOKEN_BALANCE: "token",

  // Reward related
  REFERRAL_SIGNUP: "reward",
  COMMISSION_EARNED: "reward",
  MILESTONE_REACHED: "reward",

  // System
  SYSTEM_NOTIFICATION: "system",
};

/* ======================================================
   TOKEN UTILIZATION COSTS
   ====================================================== */

export const TOKEN_COSTS = {
  SUBMIT_MATCH: 0,
  OPEN_FULL_PROFILE: 10,
  CIRCLE_OVERRIDE: 20,
  UNLOCK_CIRCLE_GROUP_MESSAGE: 10,
  UNLOCK_PRIVATE_ALBUM: 15,
  VIDEO_CHAT: 10,
  UNLOCK_DIRECT_MESSAGING: 10,
  UNLOCK_COMPATIBILITY_REPORT: 5,
  PROFILE_BOOST: 15,
  AI_COMPATIBILITY_INSIGHTS: 5,
};

export const PAGE_SIZE = 10;

/* ======================================================
   NEW ONBOARDING PROFILE SCHEMA OPTIONS
   ====================================================== */

export const WANTS_KIDS_OPTIONS = {
  NO: "No",
  YES_FULL_TIME: "Yes, minor children who live with me full-time",
  YES_SHARED_CUSTODY:
    "Yes, minor children who live with me part-time/shared custody",
  YES_ADULT_CHILDREN_LIVE_WITH_ME: "Yes, adult children who live with me",
  YES_ADULT_CHILDREN_DO_NOT_LIVE_WITH_ME:
    "Yes, adult children who do not live with me",
  YES_MINOR_AND_ADULT_CHILDREN_LIVE_WITH_ME:
    "Yes, both minor and adult children who live with me",
  PREFER_NOT_TO_SAY: "Prefer not to say",
};

export const HAS_KIDS_OPTIONS = {
  NO: "No",
  YES_FULL_TIME: "Yes, minor children who live with me full-time",
  YES_SHARED_CUSTODY:
    "Yes, minor children who live with me part-time/shared custody",
  YES_ADULT_CHILDREN_LIVE_WITH_ME: "Yes, adult children who live with me",
  YES_ADULT_CHILDREN_DO_NOT_LIVE_WITH_ME:
    "Yes, adult children who do not live with me",
  YES_MINOR_AND_ADULT_CHILDREN_LIVE_WITH_ME:
    "Yes, both minor and adult children who live with me",
  PREFER_NOT_TO_SAY: "Prefer not to say",
};

export const OPEN_TO_PARTNER_WITH_KIDS_OPTIONS = {
  YES: "Yes",
  NO: "No",
  DEPENDS: "Depends on the situation",
  PREFER_NOT_TO_SAY: "Prefer not to say",
};

export const MARRIAGE_IMPORTANCE_OPTIONS = {
  VERY_IMPORTANT: "Very important",
  IMPORTANT_NOT_URGENT: "Important, but not urgent",
  OPEN_NOT_PRIORITY: "Open to marriage, but not a priority",
  NOT_IMPORTANT: "Not important",
};

export const NON_NEGOTIABLE_OPTIONS = {
  emotionally_available: "Emotionally available",
  wants_committed_relationship: "Wants a committed relationship",
  consistent_communication: "Consistent communication",
  non_smoker: "Non-smoker",
  non_drinker: "Non-drinker",
  does_not_eat_meat: "Does not eat meat",
  physically_active: "Physically active",
  no_cat: "No cats",
  no_dog: "No dogs",
  not_atheist_secular: "Not atheist / secular",
  no_kids_under_18: "No children under 18",
  wants_kids: "Wants children",
  open_to_marriage: "Open to marriage",
};

export const LAST_SERIOUS_RELATIONSHIP_TIMING_OPTIONS = {
  WITHIN_6_MONTHS: "Within last 6 months",
  "6_TO_12_MONTHS": "6-12 months ago",
  "1_TO_2_YEARS": "1-2 years ago",
  MORE_THAN_2_YEARS: "More than 2 years ago",
  PREFER_NOT_TO_SAY: "Prefer not to say",
};

export const MATCH_SUMMARY_INTENT_OPTIONS = {
  LONG_TERM_RELATIONSHIP: "Long-term relationship",
  MARRIAGE_MINDED_RELATIONSHIP: "Marriage-minded relationship",
  SERIOUS_OPEN_TO_POSSIBILITY: "Serious, open to possibility",
  MEANINGFUL_CONNECTION_NO_PRESSURE: "Meaningful connection, no pressure",
};

export const MATCH_SUMMARY_FAMILY_OPTIONS = {
  WANTS_CHILDREN_IN_FUTURE: "Wants children in the future",
  OPEN_TO_MORE_CHILDREN: "Open to more children",
  DOES_NOT_WANT_CHILDREN: "Does not want children",
  FAMILY_COMPLETE: "Already raised my children; my family is complete",
  OPEN_TO_PARTNER_WITH_CHILDREN: "Open to a partner who has children",
  FIGURING_OUT_FAMILY_PLANS: "Still figuring out my family plans",
};

export const MATCH_SUMMARY_MINDSET_OPTIONS = {
  EXCITED_AND_HOPEFUL: "Excited and hopeful",
  CAUTIOUSLY_OPTIMISTIC: "Cautiously optimistic",
  OPEN_AND_CURIOUS: "Open and curious",
  THOUGHTFUL_AND_GUARDED: "Thoughtful and guarded",
};

export const MATCH_SUMMARY_INTEREST_OPTIONS = {
  TRAVEL_EXPLORATION: "Travel & exploration",
  FOOD_DINING: "Food & dining",
  ARTS_CULTURE: "Arts & culture",
  WELLNESS_FITNESS: "Wellness & fitness",
  SOCIAL_EVENTS: "Social events",
  INTELLECTUAL_PURSUITS: "Intellectual pursuits",
  TECHNOLOGY_INNOVATION: "Technology & innovation",
};

export const EDUCATION_LEVEL_OPTIONS = {
  HIGH_SCHOOL: "High School",
  SOME_COLLEGE: "Some college",
  BACHELORS: "Bachelor's degree",
  MASTERS: "Master's degree",
  DOCTORATE: "Doctorate",
  OTHER: "Other",
};

export const CIRCLE_RELATIONSHIP_LABELS = {
  PARENT: "Parent",
  FRIEND: "Friend",
  SIBLING: "Sibling",
  RELATIVE: "Relative",
  COWORKER: "Coworker",
  MENTOR: "Mentor",
  OTHER: "Other",
};
